import { render, staticRenderFns } from "./areaProportion.vue?vue&type=template&id=a88b3860&scoped=true&"
import script from "./areaProportion.vue?vue&type=script&lang=js&"
export * from "./areaProportion.vue?vue&type=script&lang=js&"
import style0 from "./areaProportion.vue?vue&type=style&index=0&id=a88b3860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88b3860",
  null
  
)

export default component.exports